module.exports = __webpack_public_path__ + "an.no1.87588e48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/an.no1.jpg
// module id = 0UPB
// module chunks = 0